import React, { VFC, useState } from "react"
import { Gallery, Item } from "react-photoswipe-gallery"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"

type Props = {
  items: {
    src: string
    height?: number
    width?: number
  }[]
}

const PhotoGallery: VFC<Props> = ({ items }) => {
  const [isShowAll, setIsShowAll] = useState(false)
  return (
    <>
      <div className="grid grid-cols-2 gap-5 mt-12 md:mt-20 md:gap-8 md:grid-cols-4">
        <Gallery>
          {items.map((item, index) => {
            return (
              (isShowAll || index < 8) && (
                <Item
                  original={item.src}
                  thumbnail={item.src}
                  width={item.width || "1024"}
                  height={item.height || "768"}
                  key={item.src}
                >
                  {({ ref, open }) => (
                    <img
                      ref={ref as React.MutableRefObject<HTMLImageElement>}
                      onClick={open}
                      src={item.src}
                      className="object-cover w-full h-40 rounded"
                    />
                  )}
                </Item>
              )
            )
          })}
        </Gallery>
      </div>
      {items.length > 8 && !isShowAll && (
        <button
          onClick={() => setIsShowAll(true)}
          className="flex items-center mx-auto mt-5 w-fit md:mt-8"
        >
          <span className="mr-2">もっと見る</span>
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
      )}
    </>
  )
}

export default PhotoGallery
